import List from "../../../components/Clients/List/List";

export default function Clients() {
    return <List />;
}
